export class User {
    public userId: string;
    public email: string;
    public firstName: string;
    public surname: string;
    public mobileNumber: string;
    public permissionsValue: number;
    public createdDateUtc: string;
    public loyaltySiteId: string;
    public loyaltySiteName: string;
    public password: string;
    public confirmPassword: string;
    public statusId: boolean = false;
    public roleId: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/user/user.ts